import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerPaymentMethod,
  BackendMutationUpdateCustomerPaymentMethodArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateCustomerPaymentMethod($customerId: ID!, $stripePaymentMethodId: ID!) {
    updateCustomerPaymentMethod(
      customerId: $customerId
      stripePaymentMethodId: $stripePaymentMethodId
    ) {
      card {
        brand
      }
    }
  }
`;

type Variables = BackendMutationUpdateCustomerPaymentMethodArgs;
type Result = Pick<BackendCustomerPaymentMethod, 'card'>;

export const updateCustomerPaymentMethod = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
